@if (!isLoading) {
  @if (impersonationEmail) {
    <admin-impersonation-warning
      [impersonationEmail]="impersonationEmail"
      (clearImpersonation)="clearImpersonation($event)"
    ></admin-impersonation-warning>
  }

  @if (showUrl) {
    <tgx-header (showBearerCopied)="handleCopyBearer($event)"></tgx-header>
    @if (showBearerCopied) {
      <div class="floating-xen-tag">
        <xen-tag
          [size]="'large'"
          [label]="'Bearer token copied'"
          [icon]="true"
          [icon_snippet]="'fa-regular fa-copy'"
          [icon_placement]="'left'"
          [type]="'success'"
        ></xen-tag>
      </div>
    }
    <div>
      @if (!dashboardBrowsingType) {
        <div class="container-fluid bread-bg px-md-5 px-auto py-3" [ngClass]="{ 'mb-0': isLogged, 'mb-3': !isLogged }">
          <div class="row">
            <div class="col-xxl-6 col-xl-7 col-lg-6 col-md-12 col-12 order-1 order-md-1 order-lg-0">
              <tgx-breadcrumb></tgx-breadcrumb>
            </div>
            <div
              class="col-xxl-6 col-xl-5 col-lg-6 col-md-12 d-flex align-items-center justify-content-center justify-content-md-center justify-content-lg-end"
            >
              @if (!hideBrowsingType) {
                <tgx-browsing-type-profile></tgx-browsing-type-profile>
              }
            </div>
          </div>
        </div>
        @if (isLogged) {
          <tgx-meta-help></tgx-meta-help>
        }
      }
    </div>
  }

  <router-outlet></router-outlet>

  @if (showOnboardingAlert) {
    <div class="position-fixed bottom-0 w-auto z-3 ps-4 pb-2">
      <xen-alert type="info" [dismiss]="true">
        <div class="d-flex align-items-center justify-content-center">
          <i class="fas fa-circle-info me-2"></i>
          <span class="mb-0 me-3 pe-3">
            We see <strong>you have an onboarding</strong> in progress ({{ onboardingAlertPartnerType }}).
            <xen-link
              [size]="'body'"
              [weight]="'semi-bold'"
              [theme]="'blue'"
              [label]="'Click here to continue the process'"
              (click)="changeOrganizationType()"
            ></xen-link>
          </span>
        </div>
      </xen-alert>
    </div>
  }

  @if (showUrl) {
    <tgx-footer class="mt-auto"></tgx-footer>
  }
}

<tgx-toasts></tgx-toasts>

@if (isLoading) {
  <div class="position-absolute top-50 start-50 translate-middle preloader">
    <svg width="600" height="109" viewBox="0 0 600 109" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M566.146 63.1514C566.896 71.7166 571.304 75.9992 579.369 75.9992C581.869 75.9992 584.386 75.7178 586.918 75.1552C589.45 74.5612 592.248 73.6234 595.311 72.3418L598.781 81.2977C591.154 84.8301 584.105 86.5806 577.634 86.5494C569.694 86.5494 563.457 84.2362 558.925 79.6097C554.392 74.9832 552.126 68.5593 552.126 60.338C552.126 52.1479 554.345 45.7709 558.784 41.207C563.223 36.6118 569.444 34.3142 577.446 34.3142C592.482 34.3142 600 42.8325 600 59.8691V63.1514H566.146ZM586.777 54.805C586.371 47.8028 583.292 44.3017 577.54 44.3017C574.351 44.3017 571.835 45.177 569.991 46.9275C568.178 48.6468 566.99 51.2726 566.427 54.805H586.777Z"
        fill="#282828"
        class="svg-elem-1"
      ></path>
      <path
        d="M547.202 83.6888C542.857 85.4706 538.699 86.3615 534.729 86.3615C523.663 86.3615 518.13 81.0786 518.13 70.5128V45.3798H509.831V35.2986H519.068L521.834 20.9034H532.432V35.2986H546.17V45.3798H532.432V68.4965C532.432 71.0598 532.9 72.8885 533.838 73.9826C534.807 75.0767 536.448 75.6237 538.762 75.6237C540.731 75.6237 542.841 75.233 545.092 74.4515L547.202 83.6888Z"
        fill="#282828"
        class="svg-elem-2"
      ></path>
      <path
        d="M481.556 34.3142C488.652 34.3142 494.091 36.0647 497.873 39.5658C501.656 43.0669 503.547 48.1467 503.547 54.805V85.6116H491.637L489.996 79.6566C487.933 81.8448 485.604 83.5172 483.009 84.6738C480.446 85.7992 477.695 86.3618 474.757 86.3618C469.567 86.3618 465.441 85.0177 462.378 82.3293C459.345 79.641 457.829 76.0305 457.829 71.4978C457.829 66.2461 460.033 62.1511 464.441 59.2127C468.88 56.2742 475.069 54.805 483.009 54.805H489.152V53.539C488.964 47.7247 485.666 44.8175 479.258 44.8175C477.07 44.8175 474.538 45.1457 471.662 45.8022C468.786 46.4274 466.191 47.2401 463.878 48.2404L460.83 38.5343C464.144 37.1901 467.629 36.1585 471.287 35.4395C474.944 34.6893 478.367 34.3142 481.556 34.3142ZM484.228 62.6825C480.133 62.6825 476.945 63.3858 474.663 64.7925C472.412 66.1992 471.287 68.153 471.287 70.6538C471.287 72.7169 471.912 74.2955 473.162 75.3896C474.413 76.4525 476.179 76.9839 478.461 76.9839C480.524 76.9839 482.493 76.5306 484.369 75.6241C486.276 74.7175 487.87 73.4984 489.152 71.9667V62.6825H484.228Z"
        fill="#282828"
        class="svg-elem-3"
      ></path>
      <path
        d="M423.554 34.8311C425.929 34.8311 428.149 35.175 430.212 35.8627C432.306 36.5192 434.119 37.4882 435.651 38.7699L437.105 35.3H448.733V84.7688C448.733 92.2711 446.42 97.9761 441.794 101.884C437.198 105.822 430.931 107.792 422.991 107.792C418.958 107.792 414.957 107.323 410.987 106.385C407.017 105.478 403.485 104.15 400.39 102.399L404.844 93.0214C407.095 94.2405 409.846 95.2721 413.097 96.1161C416.348 96.9914 419.349 97.429 422.1 97.429C426.007 97.429 429.008 96.4131 431.103 94.3812C433.228 92.3805 434.291 89.4265 434.291 85.519V80.2205C430.446 83.8779 425.914 85.7066 420.693 85.7066C413.722 85.7066 408.299 83.5653 404.422 79.2827C400.546 75.0001 398.608 68.9825 398.608 61.2301C398.608 52.9775 400.812 46.5223 405.22 41.8646C409.627 37.1756 415.739 34.8311 423.554 34.8311ZM426.226 44.3967C422.006 44.3967 418.771 45.8034 416.52 48.6167C414.301 51.3989 413.191 55.447 413.191 60.7612C413.191 65.5127 414.082 69.1701 415.864 71.7334C417.677 74.2655 420.271 75.5315 423.647 75.5315C426.211 75.5315 428.446 74.7969 430.353 73.3277C432.291 71.8584 433.604 69.8734 434.291 67.3727V46.5067C431.853 45.1 429.165 44.3967 426.226 44.3967Z"
        fill="#282828"
        class="svg-elem-4"
      ></path>
      <path d="M374.037 13.4023H388.432V85.6126H374.037V13.4023Z" fill="#282828" class="svg-elem-5"></path>
      <path
        d="M330.103 63.1514C330.853 71.7166 335.261 75.9992 343.326 75.9992C345.826 75.9992 348.343 75.7178 350.875 75.1552C353.407 74.5612 356.205 73.6234 359.268 72.3418L362.738 81.2977C355.111 84.8301 348.061 86.5806 341.591 86.5494C333.651 86.5494 327.414 84.2362 322.882 79.6097C318.349 74.9832 316.083 68.5593 316.083 60.338C316.083 52.1479 318.302 45.7709 322.741 41.207C327.18 36.6118 333.401 34.3142 341.403 34.3142C356.439 34.3142 363.957 42.8325 363.957 59.8691V63.1514H330.103ZM350.734 54.805C350.328 47.8028 347.249 44.3017 341.497 44.3017C338.308 44.3017 335.792 45.177 333.948 46.9275C332.135 48.6468 330.947 51.2726 330.384 54.805H350.734Z"
        fill="#282828"
        class="svg-elem-6"
      ></path>
      <path
        d="M261.408 35.2992H275.616L283.025 57.3843C283.994 60.3853 285.181 64.7616 286.588 70.5135L287.338 73.4206C287.839 71.5138 288.198 70.0758 288.417 69.1068C289.636 64.1677 290.683 60.229 291.558 57.2905L298.967 35.2992H312.987L295.685 85.612H278.711L261.408 35.2992Z"
        fill="#282828"
        class="svg-elem-7"
      ></path>
      <path
        d="M233.697 34.3142C240.793 34.3142 246.232 36.0647 250.014 39.5658C253.797 43.0669 255.688 48.1467 255.688 54.805V85.6116H243.778L242.137 79.6566C240.074 81.8448 237.745 83.5172 235.15 84.6738C232.587 85.7992 229.836 86.3618 226.898 86.3618C221.709 86.3618 217.582 85.0177 214.519 82.3293C211.487 79.641 209.971 76.0305 209.971 71.4978C209.971 66.2461 212.174 62.1511 216.582 59.2127C221.021 56.2742 227.21 54.805 235.15 54.805H241.293V53.539C241.105 47.7247 237.808 44.8175 231.399 44.8175C229.211 44.8175 226.679 45.1457 223.803 45.8022C220.927 46.4274 218.333 47.2401 216.019 48.2404L212.972 38.5343C216.285 37.1901 219.771 36.1585 223.428 35.4395C227.085 34.6893 230.508 34.3142 233.697 34.3142ZM236.37 62.6825C232.275 62.6825 229.086 63.3858 226.804 64.7925C224.553 66.1992 223.428 68.153 223.428 70.6538C223.428 72.7169 224.053 74.2955 225.304 75.3896C226.554 76.4525 228.32 76.9839 230.602 76.9839C232.665 76.9839 234.635 76.5306 236.51 75.6241C238.417 74.7175 240.011 73.4984 241.293 71.9667V62.6825H236.37Z"
        fill="#282828"
        class="svg-elem-8"
      ></path>
      <path
        d="M187.885 42.2862C191.042 37.0971 195.465 34.5025 201.154 34.5025C202.374 34.5025 203.405 34.5807 204.249 34.737C205.124 34.862 206.234 35.1121 207.578 35.4872L205.937 48.0537C203.249 47.0846 200.873 46.6157 198.81 46.647C196.559 46.647 194.652 47.0534 193.089 47.8661C191.526 48.6476 190.213 49.898 189.151 51.6173V85.6124H174.709V35.2997H186.15L187.885 42.2862Z"
        fill="#282828"
        class="svg-elem-9"
      ></path>
      <path
        d="M166.082 83.6888C161.737 85.4706 157.58 86.3615 153.61 86.3615C142.544 86.3615 137.011 81.0786 137.011 70.5128V45.3798H128.711V35.2986H137.948L140.715 20.9034H151.312V35.2986H165.051V45.3798H151.312V68.4965C151.312 71.0598 151.781 72.8885 152.719 73.9826C153.688 75.0767 155.329 75.6237 157.642 75.6237C159.612 75.6237 161.722 75.233 163.972 74.4515L166.082 83.6888Z"
        fill="#282828"
        class="svg-elem-10"
      ></path>
      <rect width="108.845" height="108.845" rx="4.29" fill="#0B59DE" class="svg-elem-11"></rect>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23.978 26.5834L44.369 56.4341L21.1268 91.4771H39.1544L63.1869 56.2295L42.5826 26.5834H23.978Z"
        fill="#FFFFFF"
        class="svg-elem-12"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M68.3711 21.1267L55.5641 40.0773L65.2019 53.4121L86.9636 21.1267H68.3711Z"
        fill="#FFFFFF"
        class="svg-elem-13"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M65.0018 58.9766L83.5943 86.0973H79.8734H64.9902L55.5641 72.3706"
        fill="#FFFFFF"
        class="svg-elem-14"
      ></path>
    </svg>
  </div>
}
